import cash_booking from "../assests/images/master/cash-booking-ratecard.svg";
import booking_ratecard from "../assests/images/master/account-booking-ratecard.svg";
import middle_mile_tat from "../assests/images/master/middle-mile-tat.svg";
import first_last_tat from "../assests/images/master/first-last-tat.svg";
export const childMaster = [
  {
    id: 1,
    parentId: 5,
    parentHeading: "Rate Card Master",
    imgSrc: cash_booking,
    title: "Cash Booking Rate Card",
    route: "/cash-booking-ratecard",
    disable: false,
  },
  {
    id: 2,
    parentId: 5,
    parentHeading: "Rate Card Master",
    imgSrc: booking_ratecard,
    title: "Account Booking Rate Card",
    route: "",
    disable: true,
  },
  {
    id: 3,
    parentId: 7,
    parentHeading: "TAT master",
    imgSrc: first_last_tat,
    title: "First & Last Mile TAT",
    route: "/first-last-mile-tat",
    disable: false,
  },
  {
    id: 4,
    parentId: 7,
    parentHeading: "TAT master",
    imgSrc: middle_mile_tat,
    title: "Middle Mile TAT",
    route: "/middle-mile-tat",
    disable: false,
  }
];
